import styles from "./DataRow.module.scss";
import { type HeaderKey } from "../../constants/metrics";
import { MetricCell } from "./MetricCell";
import type {
  MappedProduct,
  MappedStuck,
  MappedArticleData,
} from "../../types";

interface DataRowProps {
  item: MappedProduct | MappedStuck | MappedArticleData;
  columns: readonly { key: HeaderKey; label: string }[];
}

export function DataRow({ item, columns }: DataRowProps) {
  return (
    <div className={styles.dataRow}>
      {columns.map(({ key }) => (
        <div key={key} className={styles.dataColumn}>
          <div>
            <MetricCell item={item} columnKey={key} />
          </div>
        </div>
      ))}
    </div>
  );
}
